import React, { RefObject } from 'react';
import { AdacText } from '@adac-de/component-library';
import styles from './disclaimer-modal.module.scss';
import Modal from '@components/modal/modal';
import { Richtext } from '@components/richtext/richtext';
import { BackButton } from '@components/back-button/back-button';

type DisclaimerModalProps = {
  isOpen: boolean;
  toggle: () => void;
  disclaimerText: PvWizardContent['disclaimerText'];
  modalRef?: RefObject<HTMLDivElement>;
};

export const DisclaimerModal: React.FC<DisclaimerModalProps> = ({
  isOpen,
  toggle,
  disclaimerText,
  modalRef
}) => (
  <Modal
    isOpen={isOpen}
    close={toggle}
    modalRef={modalRef}
    className={styles.modal}
    size="full"
    headerContent={
      <AdacText className="margin-bottom--s" bold type="large">
        Nähere Informationen zur unverbindlichen ADAC Musterrechnung
      </AdacText>
    }
  >
    <>
      <Richtext document={disclaimerText} textType="normal" />
      <BackButton
        btnClass={styles.backBtn}
        onClick={toggle}
        tabIndex={1}
        label="zurück zum Rechner"
      />
    </>
  </Modal>
);
